import Gallery from '../../src/legacy/Gallery.tsx';
export default Gallery;
